export enum TwikeyExitStatus {
  Unknown = 'unknown',
  Ok = 'ok',
  Cancel = 'cancel',
  Fail = 'fail',
  Pending = 'pending',
}
